import { createLucideIcon } from "lucide-react";

/**
 * 下部ナビの「手帳」アイコン（PRODUCT_DEV-949 A案）。
 *
 * 開いた分厚い手帳（ページの下に厚みの線）に、右上から筆ペンを差し込んだ形。
 * lucide の `BookOpen` だと「読む本」に見え、書き込む手帳らしさが弱かった。
 * lucide に合う形が無いので自前で描き、`createLucideIcon` で他のアイコンと同じ
 * 線の太さ・角の丸め（24 グリッド・stroke 2・round）にそろえている。
 */
const DiaryPenIcon = createLucideIcon("diary-pen", [
  [
    "path",
    {
      d: "M12 8C9.3 6.3 5.8 5.9 2.5 6.5v12c3.3-.6 6.8-.2 9.5 1.5 2.7-1.7 6.2-2.1 9.5-1.5V11",
      key: "page",
    },
  ],
  ["path", { d: "M12 8v12", key: "spine" }],
  [
    "path",
    {
      d: "M2.5 18.5v2c3.3-.6 6.8-.2 9.5 1.5 2.7-1.7 6.2-2.1 9.5-1.5v-2",
      key: "thickness",
    },
  ],
  ["path", { d: "M21.6 4.4a1.5 1.5 0 0 0-2.1-2.1L14.2 7.6l-.8 3 3-.8z", key: "pen" }],
]);

export default DiaryPenIcon;
